import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Wizard from "components/Wizard/Wizard";
import WizardMini from "components/Wizard/WizardMini";
import WizardConsumer from "components/Wizard/Consumer/WizardConsumer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import WizardStart from "containers/Wizard/WizardStart";
import WizardStep from "containers/Wizard/WizardStep";
import RightPanelContainer from "containers/Wizard/RightPanel/RightPanel";

import HeaderContainer from "containers/OldProject/Header";
import GroupContainer from "containers/Group/Group";

import SingleOptimizerContainer from "containers/SingleOptimizer/SingleOptimizer";

import * as runReducer from "containers/Run/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as nextReducer from "containers/Next/NextReducer";

import { PROJECT_MODES } from "containers/Run/reducer";

import { isEnabled } from "utils/featureFlags";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getBlueprintId = (props) =>
  props && props.match && props.match.params && props.match.params.blueprintId ? props.match.params.blueprintId : "new";

const getSetupId = (props) => "new";

class WizardContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { currentStep: undefined, currentIndex: undefined };

    props.nextInit(props.datasetId);

    if (!props.isPreviewMode) {
      setTimeout(() => this.initListener(), 100);
    }

    if (props.id !== "new" && props.id !== undefined) {
      props.initPredict(props.id);
    }

    if (props.isPreviewMode) {
      return;
    }

    props.init(props.blueprintId ? props.blueprintId : "template");
  }

  componentDidUpdate(prevProps) {
    const { mode } = this.props;

    if (mode !== prevProps.mode && mode === PROJECT_MODES.RUN) {
      return this.initListener();
    }
  }

  initListener() {
    if (document.getElementById("wizardStepScroll")) {
      document.getElementById("wizardStepScroll").addEventListener("scroll", this.getCurrentStep.bind(this), true);
    } else {
      setTimeout(() => this.initListener(), 100);
    }
  }

  componentWillUnmount() {
    const { updateCreateFromProject, createFromProject } = this.props;

    if (createFromProject) {
      updateCreateFromProject(false);
    }

    document.getElementById("wizardStepScroll") &&
      document.getElementById("wizardStepScroll").removeEventListener("scroll", this.getCurrentStep.bind(this));
  }

  getCurrentStep() {
    const { mode, steps } = this.props;

    const stepTopOffset = 230;

    if (document.getElementById("wizardStepScroll") && steps) {
      const scrollTop = document.getElementById("wizardStepScroll").scrollTop;

      let minDistance = undefined;
      let retStepIndex = steps.length - 1;

      for (let i = 0; i < steps.length; i++) {
        if (document.getElementById("wizardStep_" + i)) {
          const stepOffset = document.getElementById("wizardStep_" + i).offsetTop;

          if (scrollTop + stepTopOffset > stepOffset) {
            if (minDistance === undefined || minDistance < stepOffset - (scrollTop + stepTopOffset)) {
              minDistance = stepOffset - (scrollTop + stepTopOffset);
              retStepIndex = i;
            }
          }
        }
      }

      // if (
      //   mode === PROJECT_MODES.RUN &&
      //   scrollTop +
      //     document.getElementById("wizardStepScroll").clientHeight +
      //     100 >=
      //     document.getElementById("wizardStepScroll").scrollHeight
      // ) {
      //   retStepIndex = steps.length - 1;
      // }

      if (scrollTop < 80) {
        this.setState({ currentStep: undefined, currentIndex: undefined });
      } else {
        this.setState({
          currentStep: steps[retStepIndex],
          currentIndex: retStepIndex
        });
      }
    }

    return Promise.resolve();
  }

  /*
  componentDidMount() {
    setTimeout(
      () =>
        document
          .getElementById("wizardStepScroll")
          .addEventListener("scroll", this.handleScroll.bind(this), true),
      2000
    );
  }

  componentWillUnmount() {
    document.getElementById("wizardStepScroll").removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll(e) {
    const { model } = this.props;
    const { isRightOpen } = this.state;

    const scrollDiv = document.getElementById("wizardStepScroll");

    const resultsSection = document.getElementById("resultsSection");

    if (scrollDiv) {
      if (scrollDiv.scrollHeight - scrollDiv.scrollTop >= scrollDiv.clientHeight + 10 && model) {
        isRightOpen === false && this.setState({ isRightOpen: true });
      } else {
        isRightOpen === true && this.setState({ isRightOpen: false });
      }
    }
  }
  */

  render() {
    const {
      steps,
      id,
      status,
      models,
      blueprintId,
      relatedId,
      projectId,
      modelType,
      isLoading,
      modelGroupDeploy,
      handleCancel,
      isEditBlueprint,
      isConsumerMode,
      isBusinessMode,
      stepIndex,
      isEDG
    } = this.props;

    const { currentStep, currentIndex } = this.state;

    const isMini = true;

    /*
    if (isEDG) {
      return <BlueprintContainer {...this.props} />;
    }
    */

    return isConsumerMode ? (
      <WizardConsumer {...this.props} />
    ) : isBusinessMode && id !== "new" && models.length > 1 ? (
      <SingleOptimizerContainer id={id} />
    ) : (
      <Wizard
        {...this.props}
        header={
          <HeaderContainer
            blueprintId={blueprintId}
            runId={relatedId ? relatedId : id}
            originalId={id}
            projectId={projectId}
          />
        }
        stepsContainer={
          isLoading ? (
            <LoadingIndicator />
          ) : (
            // Only render the steps that have been hit
            steps.map(
              (s, i) =>
                (isEditBlueprint || i <= stepIndex) && (
                  <WizardStep
                    blueprintId={blueprintId}
                    id={relatedId && relatedId !== -1 ? relatedId : id}
                    originalId={id}
                    type={s}
                    index={i}
                    key={i}
                    isShow
                    hasNext={i < steps.length - 1}
                    isStep={s === currentStep}
                    handleCancel={handleCancel}
                  />
                )
            )
          )
        }
        currentStep={
          <WizardStep
            blueprintId={blueprintId}
            id={relatedId && relatedId !== -1 ? relatedId : id}
            originalId={id}
            type={currentStep}
            index={currentIndex}
            style={{ borderBottom: "0px" }}
            handleCancel={handleCancel}
            isShow
            isHeader
          />
        }
        hasCurrentStep={currentStep !== undefined}
        start={<WizardStart blueprintId={blueprintId} id={id} />}
        audit={<GroupContainer id={id} />}
        rightPanel={
          <RightPanelContainer
            id={relatedId ? relatedId : id}
            originalId={id}
            blueprintId={blueprintId}
            relatedId={relatedId}
          />
        }
        mini={<WizardMini {...this.props} />}
        consumer={<WizardConsumer {...this.props} />}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const blueprintId = getBlueprintId(ownProps);
  const setupId = getSetupId(ownProps);

  return {
    init: (bId) => dispatch(blueprintReducer.init(id, bId)),
    createBlueprint: (bId) => dispatch(blueprintReducer.createBlueprint(id, bId)),

    openProject: (projectId) => dispatch(projectReducer.openProject(projectId)),

    addStep: (bId, step) => dispatch(blueprintReducer.addStep(id, bId, step)),
    removeStepById: (bId, step) => dispatch(blueprintReducer.removeStepById(id, bId, step)),
    updateSteps: (steps) => dispatch(blueprintReducer.updateSteps(blueprintId, steps)),

    scrollToId: (bId, stepId) => dispatch(wizardReducer.scrollToStepById(id, bId, stepId)),
    updateHoverStep: (step) => dispatch(wizardReducer.updateHoverStep(step)),
    updateFieldSelect: (fieldSelect) => dispatch(runReducer.updateFieldSelect(id, fieldSelect)),
    handleCancel: () => dispatch(runReducer.cancelRun(id)),
    updateCapValue: (projectId, c) => dispatch(runReducer.updateCapValue(id, projectId, c)),

    initPredict: (id) => dispatch(predictReducer.init(id)),

    predictAll: () => dispatch(predictReducer.predictAll(id, ownProps.projectId)),

    updateModelFeedback: (modelId, isLiked) => dispatch(projectReducer.updateModelFeedback(id, modelId, isLiked)),

    updateCreateFromProject: (bool) => globalReducer.updateCreateFromProject(bool),

    initJob: () => dispatch(setupReducer.initJobFromWizard(setupId)),
    updateSuccess: (success) => dispatch(setupReducer.updateSuccess(setupId, success)),
    updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId(setupId, datasetId)),
    updateCosts: (costs) => dispatch(setupReducer.updateCosts(id, costs)),
    introspectCounts: (costs) => dispatch(setupReducer.introspectCounts(id, costs)),
    updateLabel: (label) => dispatch(setupReducer.updateLabel(id, label)),
    updateConversionGain: (conversionGain) => {
      dispatch(predictReducer.updateScenarioConversionGain(ownProps.id, conversionGain));
      return dispatch(setupReducer.updateConversionGain(id, conversionGain));
    },

    updateConversionCost: (conversionCost) => {
      dispatch(predictReducer.updateScenarioConversionCost(ownProps.id, conversionCost));
      return dispatch(setupReducer.updateConversionCost(id, conversionCost));
    },

    updateConversionSaved: (conversionGain) => {
      dispatch(predictReducer.updateScenarioConversionSaved(ownProps.id, conversionGain));
      return dispatch(setupReducer.updateConversionSaved(id, conversionGain));
    },

    updateConversionMissed: (conversionCost) => {
      dispatch(predictReducer.updateScenarioConversionMissed(ownProps.id, conversionCost));
      return dispatch(setupReducer.updateConversionMissed(id, conversionCost));
    },

    validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
    handleFileChange: (file, target) => dispatch(uploadReducer.handleFileChange(file, target)),
    handleChangeOutcome: (outcome) => dispatch(uploadReducer.handleChangeOutcome(outcome)),
    handleUpload: (datasetId) => dispatch(uploadReducer.handleUpload(datasetId)),

    handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
    },

    initCustomBlueprint: (blueprintId) => dispatch(setupReducer.initCustomBlueprint(id, blueprintId)),

    handleDeleteDataset: (id) => dispatch(homeReducer.deleteDataset(id)),
    handleDeleteProject: (projectId) => dispatch(projectReducer.handleDelete(projectId)),

    getModelFeature: (modelId, feature) => dispatch(runReducer.getModelFeatureInfoWithDispatch(id, modelId, feature)),
    updateBlueprintId: (blueprintId) => {
      dispatch(blueprintReducer.setBlueprint(ownProps.id, blueprintId));

      return blueprintId === undefined && ownProps.id === "new"
        ? dispatch(setupReducer.resetSetupToDefault(ownProps.id, true))
        : dispatch(setupReducer.updateBlueprintId(ownProps.id, blueprintId));
    },
    handleSearchInsights: (options) => dispatch(nextReducer.handleSearchInsights(ownProps.nextId, options)),
    updateSearchType: (searchType) => dispatch(nextReducer.updateSearchType(ownProps.nextId, searchType, false)),

    nextInit: (datasetId) => dispatch(nextReducer.init("new", datasetId, true))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const runBlueprintId = setupReducer.getBlueprintId(state, id);
  const blueprintId = id !== "new" ? runBlueprintId : getBlueprintId(ownProps);
  const setupId = getSetupId(ownProps);
  const accounts = accountsReducer.getAccounts(state);
  const datasetId = setupReducer.getDatasetId(state, id);

  return {
    id: id,
    blueprintId: blueprintId,
    datasetId: datasetId,

    relatedId: runReducer.getRelatedId(state, id),

    steps: wizardReducer.getSteps(state, id, id !== "new" ? runBlueprintId : blueprintId),

    isEditBlueprint: (id === "new" && blueprintId === "new") || blueprintReducer.getIsEditing(state, blueprintId),

    modelType: wizardReducer.getModelType(state, id, blueprintId),
    aibleMode: wizardReducer.getAibleMode(state, id, blueprintId),

    isLoading:
      false &&
      blueprintId !== "new" &&
      blueprintId !== "template" &&
      blueprintId !== "academic" &&
      blueprintId !== undefined &&
      blueprintReducer.getIsLoadingBlueprint(state, blueprintId),

    isAdvanced: isEnabled("advanced-wizard"),

    mode: runReducer.getMode(state, id),

    modelGroupDeploy: deploymentsReducer.getModelGroupDeploy(state, id),

    model: runReducer.getSelModel(state, id),
    models: runReducer.getTransformedModels(state, id),

    status: runReducer.getStatus(state, id),

    bestModel: runReducer.getFirstModel(state, id),

    defaultCapacityModels: runReducer.getTransformedModelsDefaultCapacity(state, id),

    selectedScenario: predictReducer.getSelectedScenario(state, id),

    fieldSelect: runReducer.getFieldSelect(state, id),

    scenarios: predictReducer.getScenarios(state, id),
    scenarioIndex: predictReducer.getScenarioIndex(state, id),
    colSelections: predictReducer.getColumnSelections(state, id),

    isContinuous: runReducer.getIsContinuous(state, id),
    outcome: runReducer.getOutcome(state, id),

    outcome: setupReducer.getOutcomeFromDataset(state, id),

    dataset: homeReducer.getDataset(state, datasetId),

    deployments: viewReducer.getDeployments(state).filter((d) => d.status === "RUNNING"),
    datasets: globalReducer.getIsTableauMode(state) ? viewReducer.getDatasets(state) : undefined,

    projects: viewReducer.getProjects(state),

    isDatasetsLoading: globalReducer.getIsDatasetsLoading(state),
    isProjectsLoading: globalReducer.getIsOptimizersLoading(state),

    isTableauMode: globalReducer.getIsTableauMode(state),
    isConsumerMode: ownProps.isConsumerMode ? ownProps.isConsumerMode : globalReducer.getIsConsumerMode(state),

    orgGlobalModel: runReducer.getGlobalModel(state, id),

    processLimit: setupReducer.getProcessLimit(state, id),
    defaultProcessLimit: setupReducer.getDefaultProcessLimit(state, id),

    isBusinessMode: globalReducer.getIsBusinessMode(state),

    stepIndex: wizardReducer.getStepIndex(state),

    capModels: runReducer.getFrontier(state, id, ownProps.projectId),

    capValue: runReducer.getCapValue(state, id),
    expectedModelCount: runReducer.getExpectedModelCount(state, id),

    overallSegmentId: projectReducer.getOverallSegmentId(state, ownProps.projectId),

    createFromProject: globalReducer.getCreateFromProject(state),
    username: loginReducer.getUserName(state),

    isEDG: galleryReducer.getIsEDG(state),

    setupDatasetId: setupReducer.getDatasetId(state, setupId),
    setupSuccess: setupReducer.getSuccess(state, setupId),
    setup: setupReducer.getSetup(state, id),

    blueprints: viewReducer.getBlueprints(state),
    blueprint: blueprintReducer.getBlueprint(state, blueprintId),

    useUploadModal: accounts && accounts.length > 1,
    selectedAccountId: accountsReducer.getSelectedAccountId(state),
    isTabUploading: loginReducer.getIsTabUploading(state),
    isDataUploading: globalReducer.getIsDataUploading(state),

    nextSearchInsights: nextReducer.getSearchInsights(state, ownProps.nextId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(WizardContainer);
